import React from "react";
import { Box, Skeleton, Grid } from "@mui/material";

const DashboardSkeleton = () => {
  return (
    <Box display="flex" height="100vh" bgcolor="#1A202C">
      {/* Sidebar Skeleton - Match actual Sidebar dimensions and colors */}
      <Box
        width="225px"
        sx={{
          background:
            "linear-gradient(180deg, #0A0A23 0%, #1A1A3A 50%, #0F0F2B 100%)",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 30%, rgba(120, 119, 198, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(255, 119, 198, 0.1) 0%, transparent 50%),
              linear-gradient(135deg, rgba(255, 255, 255, 0.02) 0%, transparent 100%)
            `,
            pointerEvents: "none",
          },
        }}
        p={2}
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <Box
          mt={4}
          mb={1}
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          px={2}
        >
          <Skeleton
            variant="text"
            width="120px"
            height="60px"
            sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Box mt={2} mb={1} px={2}>
          <Skeleton
            variant="text"
            width="60%"
            height={20}
            sx={{ bgcolor: "rgba(255, 255, 255, 0.15)" }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Box mt={2} mb={1} px={2}>
          <Skeleton
            variant="text"
            width="60%"
            height={20}
            sx={{ bgcolor: "rgba(255, 255, 255, 0.15)" }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
        <Skeleton
          variant="rectangular"
          height={48}
          width="90%"
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.08)",
            borderRadius: "8px",
            mx: "auto",
          }}
        />
      </Box>

      {/* Main Content */}
      <Box flex={1} display="flex" flexDirection="column">
        {/* Navbar Skeleton */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          height="64px"
          px={3}
          bgcolor="#F7FAFC"
          borderBottom="1px solid #E2E8F0"
        >
          <Skeleton variant="text" width="30%" height={30} />
          <Skeleton variant="circular" width={40} height={40} />
        </Box>

        {/* Main Body Skeleton */}
        <Box flex={1} p={3} bgcolor="#EDF2F7">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton variant="rectangular" height={150} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton variant="rectangular" height={150} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton variant="rectangular" height={150} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton variant="rectangular" height={150} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton variant="rectangular" height={150} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton variant="rectangular" height={150} />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardSkeleton;
